<div class="kcDms-create-doc-screen-container cmn-modal-dsgn">
  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="" novalidate>
    <div class="col-12 p-0">
      <div class="cmn-modal-dsgn cmn-modal-header ">
        <h3 class="modal-header-title">{{titletext}}</h3>
      </div>
      <div class="cmn-modal-dsgn cmn-modal-content modelbody">

        <div class="row mx-0">
          <div class="col-12 p-0 borderlinel">
            <div class="row mx-0 metadata-heading">
              <h4>
                <strong class="color-code">
                  General
                </strong>
              </h4>
            </div>
            <div class="form-group">
              <div class="row align-items-center">
                <h6 class="cmn-form-label mb-0 text-left col-4 ml-4">
                  Type
                </h6>
                <div class="col-7">
                  <div class="form-select-container">
                    <ng-select [items]="documentTypeList" class="cmn-ngselect wthout-ellipsis-option" 
                      bindLabel="documentTypeName" bindValue="documentTypeId" placeholder="Select"
                      [searchable]="false" [clearable]="false" formControlName="DocumentType">
                    </ng-select>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row align-items-center">
                <h6 class="cmn-form-label mb-0 text-left col-4 ml-4">
                  <span>Template</span>
                  <span class="requireimg">*</span>
                </h6>
                <div class="col-7">
                  <div class="form-input-container">
                    <input type="text" class="folderLocationInput form-control pointer" formControlName="Template"
                      placeholder="Select template" (keydown)="preventInput($event)"
                      (focus)="openLocateTemplatePopup(LocateTemplatePopup)" />
                  </div>

                  <div *ngIf="form.get('Template')?.touched && form.get('Template')?.invalid" class="invalid-feedback">
                    Template is required.
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row align-items-center">
                <h6 class="cmn-form-label mb-0 text-left col-4 ml-4">
                  <span>File name</span>
                </h6>
                <div class="col-7">
                  <div class="form-input-container input-group">
                    <input type="text" class="folderLocationInput form-control " formControlName="FileName" />
                    <img *ngIf="selectedTemplateName" [src]="getImageForFile(selectedTemplateName)"
                      class="folderLocationimg img-responsives" />
                  </div>
                  <div *ngIf="form.get('FileName')?.errors?.['emptyString'] && form.get('FileName')?.touched"
                    class="invalid-feedback">
                    File name is required.
                  </div>
                  <!-- Invalid character error -->
                  <div *ngIf="form.get('FileName')?.errors?.['invalidCharacters'] && form.get('FileName')?.touched"
                    class="invalid-feedback">
                    {{msg_FORBIDDEN_FILENAME_CHARS_PATTERN}}
                  </div>
                  <!-- Invalid character error -->
                  <div *ngIf="form.get('FileName').errors?.reservedFileName" class="invalid-feedback">                                            
                      {{msg_RESERVED_FILE_NAMES_PATTERN}}
                  </div>
                  <!-- Max length error -->
                  <div *ngIf="form.get('FileName')?.errors?.['maxlength'] && form.get('FileName')?.touched" class="invalid-feedback">
                    Max 500 characters allowed
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group">
              <div class="row align-items-center">
                <h6 class="cmn-form-label mb-0 text-left col-4 ml-4">
                  <span>Client group</span>
                </h6>
                <div class="col-7">
                  <div class="form-select-container">

                    <ng-select [items]="clientgroups" [virtualScroll]="true" [searchable]="true" class="cmn-ngselect wthout-ellipsis-option" bindLabel="GroupName"
                      formControlName="Clientgroup" bindValue="GroupCode" placeholder="Select client group"
                      (change)="onSelectClientgroups($event)">
                      <ng-template ng-option-tmp let-item="item" let-index="index">
                        <span>{{item.GroupName}}</span>
                      </ng-template>
                    </ng-select>

                  </div>
                </div>
              </div>
            </div>

            <div class="form-group">
              <div class="row align-items-center">
                <h6 class="cmn-form-label mb-0 text-left col-4 ml-4">
                  <span>Client name</span>
                  <span class="requireimg">*</span>
                </h6>
                <div class="col-7">
                  <div class="form-select-container">
                    <ng-select [items]="clients" [virtualScroll]="true" [searchable]="true" class="cmn-ngselect wthout-ellipsis-option" bindLabel="Name"
                      formControlName="Clientname" bindValue="ClientId" placeholder="Select client name"
                      (change)="onSelectClientname($event)">
                      <ng-template ng-option-tmp let-item="item" let-index="index">
                        <span>{{item.Name}}</span>
                      </ng-template>
                    </ng-select>
                  </div>
                  <div *ngIf="form.get('Clientname')?.touched && form.get('Clientname')?.invalid"
                    class="invalid-feedback">
                    Client name is required.
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group">
              <div class="row align-items-center">
                <h6 class="cmn-form-label mb-0 text-left col-4 ml-4">
                  <span>Client code</span>
                </h6>
                <div class="col-7">
                  <div class="form-input-container ">
                    <input type="text" class="form-control" [readOnly]="true" formControlName="ClientCode"
                      value="{{clientCode}}" placeholder="Client code" />
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group">
              <div class="row align-items-center">
                <h6 class="cmn-form-label mb-0 text-left col-4 ml-4">
                  <span>Folder location</span>
                  <span class="requireimg">*</span>
                </h6>
                <div class="col-7">
                  <div class="form-input-container input-group">
                    <input type="text" class="folderLocationInput form-control " formControlName="FolderLocation"
                      (keydown)="preventInput($event)" (focus)="openLocateFolderPopup(LocateFolderPopup)" />
                    <img (click)="openLocateFolderPopup(LocateFolderPopup)" alt=""
                      src="../../../assets/img/dms-icons/folder_location.svg"
                      class="folderLocationimg folderLocationimg img-responsive" />
                  </div>

                  <div *ngIf="form.get('FolderLocation')?.touched && form.get('FolderLocation')?.invalid"
                    class="invalid-feedback">
                    Folder location is required.
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group">
              <div class="row align-items-top">
                <h6 class="cmn-form-label mb-0 text-left col-4 ml-4 mt-2">
                  <span>Description</span>
                </h6>
                <div class="col-7">
                  <div class="form-textarea-container ">
                    <textarea type="text" rows="3" class="form-control" formControlName="Description"
                      placeholder="Description"></textarea>

                  </div>
                </div>
              </div>
            </div>

            <div class="form-group">
              <div class="row align-items-center">
                <h6 class="cmn-form-label mb-0 text-left col-4 ml-4">
                  <span>Open with</span>
                </h6>
                <div class="col-7">
                  <div class="form-select-container">
                    <ng-select [items]="openWithList" bindLabel="name" bindValue="Id" class="cmn-ngselect"
                      formControlName="OpenWith" [clearable]="true" placeholder="Select open with"
                      (change)="onChangeOpenWith($event)">
                      <ng-template ng-option-tmp let-item="item" let-index="index">
                        <span class=""> {{item.name}}</span>
                      </ng-template>
                    </ng-select>
                  </div>
                </div>
              </div>
            </div>

           <!-- Meta data section starts -->
            <div *ngIf="metaDataFields?.length > 0" class="row mx-0 metadata-heading">
              <h4 class="mb-0">
                <strong class="color-code">
                  Metadata
                </strong>
              </h4>
            </div>

            <div class="form-group">
              <div *ngFor="let field of metaDataFields" class="row align-items-center row-adjustment"
                [ngClass]="{ 'radiobtnAlgn': field.DataType === 'YESNO'}">
                <h6 [attr.for]="field.SharepointSiteMetadataId"
                  class="cmn-form-label mb-0 text-left col-4 ml-4 adjustment">
                  {{ field.FieldLabel }}
                  <span *ngIf="field.Mandate" class="requireimg">*</span>
                </h6>
                <div [ngSwitch]="field.DataType" class="col-7">
                  <div class="form-input-container w-260 pt-3">
                    <!-- Text input -->
                    <input *ngSwitchCase="'TEXT'" class="form-control"
                      [formControlName]="field.SharepointSiteMetadataId.toString()" type="text" (input)="
                                updateFormValuesArray(
                                  field.SharepointSiteMetadataId,
                                  $event.target
                                )
                              " />

                    <!-- Choice select -->
                    <div class="form-multiselect-container" *ngSwitchCase="'CHOICE'">
                      <ng-multiselect-dropdown class="cmn-multiselect-dropdown ellipsis-itemname"
                        [placeholder]="'Select option'" [settings]="dropdownSettings1" [data]="field.choiceArray"
                        (onSelect)="onItemSelect($event, field)" (onSelectAll)="onSelectAll($event, field)"
                        (onDeSelect)="onDeSelect($event, field)" (onDeSelectAll)="onItemDeSelectAll(field)"
                        [formControlName]="field.SharepointSiteMetadataId.toString()">
                      </ng-multiselect-dropdown>
                    </div>

                    <!-- Date input -->
                    <div class="form-datepicker-container cmn-material-datepicker" *ngSwitchCase="'DATE'">
                      <mat-form-field floatLabel="never" appearance="standard">
                        <input class="cmn-mat-dtpicker-input" matInput [max]="maxDate"
                          [formControlName]="field.SharepointSiteMetadataId.toString()" [matDatepicker]="testDatepicker"
                          autocomplete="off" placeholder="dd/mm/yyyy" (dateChange)="checkOnchangefield()">
                        <mat-datepicker-toggle class="cmn-mat-dtpicker-togglebtn" matIconSuffix
                          [for]="testDatepicker"></mat-datepicker-toggle>
                        <mat-datepicker panelClass="cmn-datepicker-ui" #testDatepicker></mat-datepicker>
                      </mat-form-field>
                    </div>

                    <!-- Yes/No radio buttons -->
                    <div class="customefields-checkboxes ng-star-inserted" *ngSwitchCase="'YESNO'">
                      <div class="fncy-radio-button cmn-radio ng-star-inserted postion-relative">
                        <input type="radio" [formControlName]="field.SharepointSiteMetadataId.toString()" value="true"
                          id="yes{{ field.SharepointSiteMetadataId }}"
                          name="cfchkbox-{{ field.SharepointSiteMetadataId }}"
                          (change)="onYesNoChange($event, field, 'true')" />
                        <label class="radio-btn-label" for="yes{{ field.SharepointSiteMetadataId }}">Yes</label>
                      </div>
                      <div class="fncy-radio-button cmn-radio ng-star-inserted postion-relative">
                        <input type="radio" [formControlName]="field.SharepointSiteMetadataId.toString()" value="false"
                          class="check_box_add_contact_css check-label radio-button"
                          id="no{{ field.SharepointSiteMetadataId }}"
                          name="cfchkbox-{{ field.SharepointSiteMetadataId }}"
                          (change)="onYesNoChange($event, field, 'false')" />
                        <label class="radio-btn-label" for="no{{ field.SharepointSiteMetadataId }}">No</label>
                      </div>
                    </div>
                    <!-- Error message -->
                    <div *ngIf="isFieldInvalid(field.SharepointSiteMetadataId.toString())"
                      class="invalid-feedback invalid">
                      {{field.FieldLabel}} is required
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Meta data section ends -->
          </div>
          <div class="col-6 p-0 borderliner" *ngIf="previewUrl && false">
            <p>Preview SharePoint File</p>
            <a *ngIf="previewUrl" [href]="previewUrl" target="_blank">Open in SharePoint</a>

            <iframe *ngIf="previewUrl" [src]="previewUrl" width="100%" height="600px" style="border: none;"></iframe>

            <p *ngIf="!previewUrl">No preview available.</p>
          </div>

        </div>
      </div>
      <div class="cmn-modal-dsgn cmn-modal-footer">
        <button type="button" mat-button class="cmn-border-btn mr-2"
          (click)="onSubmitCreateOpen()">{{btntxtCreateOpen}}</button>
        <button type="button" mat-button class="cmn-blue-btn ml-2"
          (click)="onSubmitCreate()">{{btntxtCreate}}</button>
        <button type="button" class="cmn-inverse-btn ml-2" mat-button data-dismiss="modal"
          (click)="closeModel()">Cancel</button>
      </div>
    </div>
  </form>
</div>
<ng-template #LocateFolderPopup>
  <app-dms-folder-location (outputParameter)="hidePopUp()" (sendFolderLocation)="sendFolderLocation($event)"
    [ClientId]="clientId" [currentFolderLocId]="currentFolderLocId"></app-dms-folder-location>
</ng-template>

<ng-template #LocateTemplatePopup>
  <app-dms-template-location *ngIf="showTemplatePopup" (outputParameter)="hidePopUp()"
    (sendFolderLocation)="onTemplateSelect($event)" [driveId]="driveId" [driveItemId]="driveItemId"
    [templatedatList]="templates"></app-dms-template-location>
</ng-template>